import { Star, Quote } from "lucide-react";

export const Reviews = ({ t }) => {
  return (
    <section
      id="reviews"
      className="relative py-14 md:py-20 bg-bendito-surface"
      data-testid="reviews-section"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8 lg:px-12">
        <div className="mb-12 max-w-2xl reveal">
          <div className="eyebrow mb-3">{t.reviews.eyebrow}</div>
          <h2 className="font-heading text-bendito-ink text-4xl md:text-5xl lg:text-6xl uppercase tracking-tight">
            <span className="ink-underline">{t.reviews.title}</span>
          </h2>
          <p className="text-bendito-muted mt-3">{t.reviews.sub}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {t.reviews.items.map((r, i) => (
            <article
              key={i}
              className="bg-bendito-bg border border-bendito-border p-7 md:p-8 hover:border-bendito-orange transition-colors"
              data-testid={`review-${i}`}
            >
              <Quote className="w-8 h-8 text-bendito-orange/70 mb-4" strokeWidth={1.4} />
              <p className="text-bendito-ink/95 leading-relaxed text-base">
                "{r.quote}"
              </p>
              <div className="flex items-center justify-between mt-6 pt-5 border-t border-bendito-border">
                <div>
                  <div className="text-bendito-ink font-heading tracking-wider text-lg">
                    {r.name}
                  </div>
                  <div className="text-bendito-muted text-xs font-mono mt-1">{r.country}</div>
                </div>
                <div className="flex gap-0.5">
                  {Array.from({ length: r.stars }).map((_, j) => (
                    <Star key={j} className="w-4 h-4 fill-bendito-orange text-bendito-orange" />
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-10 text-center">
          <a
            href="https://www.google.com/search?q=Bendito+Tattoo+Playa+del+Carmen"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 font-mono text-xs tracking-[0.25em] uppercase text-bendito-muted hover:text-bendito-orange transition-colors"
            data-testid="reviews-leave-link"
          >
            {t.reviews.leave} →
          </a>
        </div>
      </div>
    </section>
  );
};

export default Reviews;
